module.exports = __webpack_public_path__ + "static/media/gift-list3.664c9db9.png";